
import PropTypes from 'prop-types';
import CustomText from './custom-text.atom';

const CustomCheckbox = ({ label, checked, onChange, disabled,  checkboxStyle = {}, ...additionalProps }) => {
    const handleClick = () => {
        if (!disabled) {
            onChange(!checked);
        }
    };

    return (
        <div 
            style={styles.container}
            onClick={handleClick}
            role="checkbox"
            aria-checked={checked}
            aria-disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            {...additionalProps}
        >
            <div
                style={{
                    ...styles.checkbox,
                    ...(checked && styles.checked),
                    ...(disabled && styles.disabledCheckbox),
                    ...checkboxStyle,
                }}
            >
                {checked && <div style={styles.checkmark} />}
            </div>
            {label && (
                <CustomText
                    variant="body"
                    style={{
                        ...styles.label,
                        ...(disabled && styles.disabledLabel)
                    }}
                >
                    {label}
                </CustomText>
            )}
        </div>
    );
};

CustomCheckbox.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        cursor: 'pointer',
        userSelect: 'none',
    },
    checkbox: {
        width: '24px',
        height: '24px',
        border: 'solid',
        borderColor: '#626262',
        borderWidth: '1px',
        borderRadius: '2px',
        backgroundColor: 'transparent',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'all 0.2s ease',
    },
    checked: {
        backgroundColor: '#FACE07',
        borderColor: '#FACE07',
    },
    disabledCheckbox: {
        backgroundColor: '#909090',
        borderColor: '#909090',
        cursor: 'not-allowed',
    },
    checkmark: {
        width: '8px',
        height: '14px',
        borderRight: '2px solid white',
        borderBottom: '2px solid white',
        transform: 'rotate(45deg)',
        marginTop: '-4px',
    },
    label: {
        marginLeft: '8px',
        color: '#000',
    },
    disabledLabel: {
        color: '#909090',
    },
};

export default CustomCheckbox; 